import { LineChartView } from 'backbone/shared/views/chartist/line_chart_view.js.coffee';
import { LineChartTooltipView } from 'backbone/shared/views/chartist/line_chart_tooltip_view.js.coffee';

import ConfirmDeleteModalView from 'backbone/shared/views/confirm_delete_modal_view.js'
import GlobalSearchBox from 'backbone/shared/views/global_search_box.js'
import GoogleLocationView from 'backbone/shared/views/google_location_view.js'
import LocalizeView from 'backbone/shared/views/localize_view.coffee'
import PasswordRequirementsView from 'backbone/shared/views/password_requirements_view.js'
import ProfileEditView from 'backbone/shared/views/profile_edit_view.js'
import SelectAllCheckboxes from 'backbone/shared/views/select_all_checkboxes_view.js'
import S3UploaderView from 'backbone/shared/views/s3_uploader_view.js'

const Backbone = {
  LineChartView,
  LineChartTooltipView,
  ConfirmDeleteModalView,
  GlobalSearchBox,
  GoogleLocationView,
  LocalizeView,
  PasswordRequirementsView,
  ProfileEditView,
  SelectAllCheckboxes,
  S3UploaderView
};

export { Backbone };



// WEBPACK FOOTER //
// ./app/javascript/backbone/shared/shared.js